import React from 'react';

const stats = [
  {
    icon: 'https://customer-assets.emergentagent.com/job_77845016-0cff-4a07-b056-0e435a63b242/artifacts/s71u7dpq_Books%20Published.gif',
    number: '2,500+',
    label: 'Books Published',
    description: 'Across all genres and formats'
  },
  {
    icon: 'https://customer-assets.emergentagent.com/job_77845016-0cff-4a07-b056-0e435a63b242/artifacts/56iauid6_Awards%20Won.gif',
    number: '150+',
    label: 'Awards Won',
    description: 'Industry recognition'
  },
  {
    icon: 'https://customer-assets.emergentagent.com/job_77845016-0cff-4a07-b056-0e435a63b242/artifacts/182ibqaq_Success%20Rate.gif',
    number: '98%',
    label: 'Success Rate',
    description: 'Client satisfaction score'
  },
  {
    icon: 'https://customer-assets.emergentagent.com/job_77845016-0cff-4a07-b056-0e435a63b242/artifacts/acnb6r7x_Countries.gif',
    number: '50+',
    label: 'Countries',
    description: 'Global distribution reach'
  }
];

const Statistics = () => {
  return (
    <section className="py-20 bg-transparent">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 border-2 border-amber-700 rounded-full mb-6">
            <span className="text-amber-700 text-sm font-semibold tracking-wider">OUR ACHIEVEMENTS</span>
          </div>
          <h2 className="text-5xl font-bold text-gray-900 mb-4">
            Publishing Excellence by the <span className="text-amber-700">Numbers</span>
          </h2>
        </div>

        {/* Stats Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
          {stats.map((stat, index) => {
            return (
              <div
                key={index}
                className="relative group h-full"
              >
                <div className="bg-white rounded-2xl p-8 shadow-2xl hover:shadow-xl transition-all duration-300 h-full flex flex-col">
                  {/* Icon */}
                  <div className="mb-6">
                    <div className="w-20 h-20 flex items-center justify-center">
                      <img 
                        src={stat.icon} 
                        alt={stat.label}
                        className="w-full h-full object-contain"
                      />
                    </div>
                  </div>

                  {/* Number */}
                  <div className="text-5xl font-bold text-gray-900 mb-2">{stat.number}</div>
                  
                  {/* Label */}
                  <div className="text-xl font-semibold text-amber-700 mb-2">{stat.label}</div>
                  
                  {/* Description */}
                  <div className="text-gray-600">{stat.description}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Statistics;